// extracted by mini-css-extract-plugin
module.exports = {"line-break":"_1_e_qQ6rMkp0JSdVIQTJMv","prefix":"_2WnEBinIyoRwz9g340TMHa"};